// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1) return "static/chunks/95f69eaa.6ef774f2f6d32388.js";
	if (chunkId === 469) return "static/chunks/469.0f3f3ed8633d0e07.js";
	if (chunkId === 72) return "static/chunks/72.5b380db3d05d629b.js";
	if (chunkId === 669) return "static/chunks/669.c6f8c0494955f02b.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 775 ? "a9db0fd6" : chunkId) + "-" + {"155":"054ab80fbcf3f156","194":"e27e9fc10360b304","427":"1c40b3952ef64bc9","709":"10bfc39ae732ada7","775":"806394305152a6bd"}[chunkId] + ".js";
};